import React from 'react';
import { useTranslation } from 'react-i18next';
import './OutputModeInput.scss';
import AggregatorOutputModePoponIcon from '../../../images/aggregator-mode-popon-icon.png';
import AggregatorOutputModeRollupIcon from '../../../images/aggregator-mode-rollup-icon.png';
import { AggregatorOutputModeEnum } from '../../../types/enums/AggregatorOutputModeEnum';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';

const OutputModeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        aggregatorOutputMode: value,
      });
    } else {
      updateEncoder(project.encoder, {
        aggregatorOutputMode: value,
      });
    }
  };

  return (
    <div className="output-mode-input">
      <div className="input-title">{t('producer.inputs.output-mode.title')}</div>
      <ToggleButton
        leftValue={AggregatorOutputModeEnum.Popon}
        leftImage={AggregatorOutputModePoponIcon}
        leftButtonClassName={`${
          project.encoder?.aggregatorOutputMode === AggregatorOutputModeEnum.Popon
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightValue={AggregatorOutputModeEnum.Rollup}
        rightImage={AggregatorOutputModeRollupIcon}
        rightButtonClassName={`${
          project.encoder?.aggregatorOutputMode === AggregatorOutputModeEnum.Rollup
            ? 'control-panel-button-selected-button'
            : null
        }`}
        footerText={t('producer.inputs.output-mode.footer')}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.inputs.output-mode.accessibility.popon')}
        rightAccessibilityName={t('producer.inputs.output-mode.accessibility.rollup')}
      />
    </div>
  );
};

export default React.memo(OutputModeInput);
